import React, { useState } from "react";
import { Button, Container, Dropdown, Form, Nav, NavDropdown, Navbar } from "react-bootstrap";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

// css
import styles from "./Header.module.scss";

// img
import logo from "../../Assets/images/logo.png";
import user from "../../Assets/images/user.png";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/actions";
import ConfirmModel from "../Modals/ConfirmModel";
import { getGreeting } from "../../utilities/utilities";

const Header = ({ sidebar, setSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const profileImage = useSelector((s) => s?.auth?.profileImage);

  const [logoutModelStatus, setLogoutModelStatus] = useState(false);

  const pageName = location.pathname;
  let lastSlashIndex = pageName.lastIndexOf("/");

  let heading;
  if (lastSlashIndex !== -1) {
    const afterLastSlash = pageName.substring(lastSlashIndex + 1);
    heading = afterLastSlash;
  }
  const handleSidebar = () => {
    setSidebar(!sidebar);
  };

  const logoutHandler = () => {
    function callBack() {
      navigate("/login");
    }
    dispatch(logout(callBack));
  };

  return (
    <>
      <ConfirmModel
        confirmHandler={logoutHandler}
        modelStatus={logoutModelStatus}
        setModel={setLogoutModelStatus}
        type={"logout"}
      />
      <header
        className={`${styles.siteHeader}  siteHeader  sticky-top pt-lg-3 py-1 w-100`}
        style={{ zIndex: 99, background: "#F6F4F4" }}
      >
        <Container>
          <Navbar expand="lg" className="p-0 border-bottom pb-2">
            <Button
              onClick={handleSidebar}
              className="d-lg-none border-0 p-0"
              variant="transparent"
              style={{ width: 56 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M3.75 10.5C3.55109 10.5 3.36032 10.4209 3.21967 10.2803C3.07902 10.1396 3 9.94887 3 9.74996V3.75146C3 3.55255 3.07902 3.36179 3.21967 3.22113C3.36032 3.08048 3.55109 3.00146 3.75 3.00146H9.75C9.94891 3.00146 10.1397 3.08048 10.2803 3.22113C10.421 3.36179 10.5 3.55255 10.5 3.75146V9.74996C10.5 9.94887 10.421 10.1396 10.2803 10.2803C10.1397 10.4209 9.94891 10.5 9.75 10.5H3.75ZM14.25 10.5C14.0511 10.5 13.8603 10.4209 13.7197 10.2803C13.579 10.1396 13.5 9.94887 13.5 9.74996V3.75146C13.5 3.55255 13.579 3.36179 13.7197 3.22113C13.8603 3.08048 14.0511 3.00146 14.25 3.00146H20.2485C20.4474 3.00146 20.6382 3.08048 20.7788 3.22113C20.9195 3.36179 20.9985 3.55255 20.9985 3.75146V9.74996C20.9985 9.94887 20.9195 10.1396 20.7788 10.2803C20.6382 10.4209 20.4474 10.5 20.2485 10.5H14.25ZM3.75 21C3.55109 21 3.36032 20.9209 3.21967 20.7803C3.07902 20.6396 3 20.4489 3 20.25V14.25C3 14.051 3.07902 13.8603 3.21967 13.7196C3.36032 13.579 3.55109 13.5 3.75 13.5H9.75C9.94891 13.5 10.1397 13.579 10.2803 13.7196C10.421 13.8603 10.5 14.051 10.5 14.25V20.25C10.5 20.4489 10.421 20.6396 10.2803 20.7803C10.1397 20.9209 9.94891 21 9.75 21H3.75ZM14.25 21C14.0511 21 13.8603 20.9209 13.7197 20.7803C13.579 20.6396 13.5 20.4489 13.5 20.25V14.25C13.5 14.051 13.579 13.8603 13.7197 13.7196C13.8603 13.579 14.0511 13.5 14.25 13.5H20.2485C20.4474 13.5 20.6382 13.579 20.7788 13.7196C20.9195 13.8603 20.9985 14.051 20.9985 14.25V20.25C20.9985 20.4489 20.9195 20.6396 20.7788 20.7803C20.6382 20.9209 20.4474 21 20.2485 21H14.25Z"
                  fill="#C11111"
                />
              </svg>
            </Button>
            <Navbar.Brand className={`${styles.logo} d-lg-none`} href="#">
              <img src={logo} alt="" className={`img-fluid`} />
            </Navbar.Brand>
            <h5 className={`${styles.location} m-0 fw-sbold text-capitalize d-lg-block d-none`}>
              {getGreeting()}, {localStorage.getItem("name") || ""}
            </h5>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse className={` justify-content-end gap-10`} id="navbarScroll">
              {/* <Form
                className={`${styles.searchForm} mx-lg-2 position-relative`}
              >
                <div className="iconWithText position-relative">
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    className=" rounded-pill bg-white ps-3"
                    aria-label="Search"
                  />
                  <Button
                    variant="transparent"
                    className="border-0 icn p-0 position-absolute"
                    style={{ right: 10 }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <path
                        d="M11.529 0C6.30699 0 2.05851 4.24848 2.05851 9.47051C2.05851 11.3211 2.59249 13.0491 3.51386 14.5094L0.615946 17.4073C-0.205966 18.2292 -0.205966 19.5617 0.615946 20.3836C1.43786 21.2055 2.77037 21.2055 3.5922 20.3836L6.49012 17.4857C7.95048 18.407 9.67847 18.941 11.529 18.941C16.751 18.941 20.9995 14.6925 20.9995 9.47051C20.9995 4.24848 16.7511 0 11.529 0ZM11.529 16.8365C7.46744 16.8365 4.16306 13.5321 4.16306 9.47051C4.16306 5.40894 7.4674 2.10455 11.529 2.10455C15.5906 2.10455 18.895 5.40894 18.895 9.47051C18.895 13.5321 15.5907 16.8365 11.529 16.8365Z"
                        fill="#919191"
                      />
                    </svg>
                  </Button>
                </div>
              </Form> */}
              <Nav className=" my-2 my-lg-0 align-items-center">
                <Dropdown className={`${styles.notificationDropdown} noAfter`}>
                  <div
                    className="position-fixed h-100 w-100 bg-dark d-none"
                    style={{ left: 0, top: 0, opacity: 0.5 }}
                  ></div>
                  <Dropdown.Toggle
                    className={`border-0 p-0`}
                    variant="transparent"
                    id="dropdown-basic"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="24"
                      viewBox="0 0 29 38"
                      fill="none"
                    >
                      <path
                        d="M26.2695 23.8668V16.6152C26.2695 10.9429 22.3648 6.16588 17.1023 4.82965C17.3262 4.38129 17.4529 3.87616 17.4529 3.34185C17.4531 1.49915 15.9539 0 14.1113 0C12.2687 0 10.7695 1.49915 10.7695 3.34178C10.7695 3.87608 10.8963 4.38122 11.1202 4.82957C5.8578 6.16581 1.95307 10.9429 1.95307 16.6151V23.8667C1.95307 26.6651 1.47517 29.4199 0.532446 32.0547L0 33.5431H8.65303C9.17026 36.0829 11.4211 38 14.1112 38C16.8014 38 19.0522 36.0829 19.5694 33.5431H28.2225L27.6901 32.0548C26.7474 29.42 26.2695 26.6651 26.2695 23.8668ZM14.1113 2.22664C14.7261 2.22664 15.2264 2.72688 15.2264 3.34178C15.2264 3.95661 14.7262 4.45684 14.1113 4.45684C13.4965 4.45684 12.9962 3.95676 12.9962 3.34178C12.9962 2.72695 13.4964 2.22664 14.1113 2.22664ZM14.1113 35.7734C12.658 35.7734 11.4188 34.841 10.9591 33.5432H17.2636C16.8037 34.841 15.5647 35.7734 14.1113 35.7734ZM3.11289 31.3165C3.82138 28.8976 4.17978 26.3985 4.17978 23.8668V16.6152C4.17978 11.1389 8.63507 6.68356 14.1114 6.68356C19.5877 6.68356 24.043 11.1388 24.043 16.6152V23.8668C24.043 26.3985 24.4013 28.8976 25.1099 31.3165H3.11289Z"
                        fill="#909090"
                      />
                    </svg>
                  </Dropdown.Toggle>

                  {/* <Dropdown.Menu className={`${styles.menu} rounded-0 pt-0 shadow-sm border-0`}>
                    <div
                      className={`${styles.top} top py-3 px-3 d-flex justify-content-between align-items-center mb-2`}
                    >
                      <h4 className="m-0 fw-sbold">
                        Notifications{" "}
                        <span
                          className={`${styles.count} text-white rounded-circle fw-normal d-inline-flex align-items-center justify-content-center`}
                        >
                          2
                        </span>
                      </h4>
                      <div className="right d-flex align-items-center gap-10">
                        <Button
                          style={{ fontSize: 12 }}
                          className="border-0 p-0 text-primary"
                          variant="transparent"
                        >
                          Mark all as read
                        </Button>
                        <Button className="border-0 p-0" variant="transparent">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="4"
                            height="19"
                            viewBox="0 0 4 19"
                            fill="none"
                          >
                            <circle cx="1.64589" cy="1.59413" r="1.55019" fill="#80849D" />
                            <circle cx="1.64589" cy="9.03456" r="1.55019" fill="#80849D" />
                            <circle cx="1.64589" cy="16.476" r="1.55019" fill="#80849D" />
                          </svg>
                        </Button>
                      </div>
                    </div>
                    <div className="ContentBody">
                      <ul className={`${styles.notificationList} list-unstyled ps-0 mb-0`}>
                        <li className="py-3 d-flex align-items-start gap-10 px-3">
                          <div
                            className="imgWrp rounded-circle"
                            style={{
                              height: 40,
                              width: 40,
                              background: "#6CBC6E",
                            }}
                          >
                          
                          </div>
                          <div className="content">
                            <h6 className="fw-bold text-dark m-0">Edward Curr</h6>
                            <p className=" text-muted m-0">
                              agency driver submits their profile for verification
                            </p>
                            <div className="btnWrpper my-2 d-flex align-items-center gap-10">
                              <Button className="d-flex align-items-center justify-content-center h-auto commonBtn">
                                Approve
                              </Button>
                              <Button
                                className="d-flex align-items-center justify-content-center h-auto commonBtn bg-transparent text-muted broder-light"
                                style={{ borderColor: "#ddd" }}
                              >
                                Approve
                              </Button>
                            </div>
                            <p className="m-0 text-muted">17 min ago</p>
                          </div>
                        </li>
                        <li className="py-3 d-flex align-items-start gap-10 px-3">
                          <div
                            className="imgWrp rounded-circle"
                            style={{
                              height: 40,
                              width: 40,
                              background: "#6CBC6E",
                            }}
                          >
                            <img
                              src={user}
                              alt=""
                              className="img-fluid h-100 w-100 rounded-circle"
                              style={{ objectFit: "cover" }}
                            />
                          </div>
                          <div className="content">
                            <h6 className="fw-bold text-dark m-0">Edward Curr</h6>
                            <p className=" text-muted m-0">
                              agency driver submits their profile for verification
                            </p>
                            <div className="btnWrpper my-2 d-flex align-items-center gap-10">
                              <Button className="d-flex align-items-center justify-content-center h-auto commonBtn">
                                Approve
                              </Button>
                              <Button
                                className="d-flex align-items-center justify-content-center h-auto commonBtn bg-transparent text-muted broder-light"
                                style={{ borderColor: "#ddd" }}
                              >
                                Approve
                              </Button>
                            </div>
                            <p className="m-0 text-muted">17 min ago</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </Dropdown.Menu> */}
                </Dropdown>

                <Link className="px-3" to="/setting/profile">
                  <img
                    src={profileImage || user}
                    style={{ aspectRatio: 1, height: 40, width: 40 }}
                    alt=""
                    className="img-fluid rounded-circle object-fit-cover"
                  />
                </Link>
                <Button
                  onClick={() => setLogoutModelStatus(true)}
                  variant="transparent"
                  className="px-3 border-0"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="26"
                    viewBox="0 0 25 26"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.89988 0.153897C10.4448 -0.00955909 11.0203 -0.0433727 11.5806 0.0551557C12.1409 0.153684 12.6704 0.381826 13.1268 0.72137C13.5832 1.06091 13.9539 1.50246 14.2094 2.01076C14.4648 2.51905 14.5979 3.08003 14.598 3.6489V21.439C14.5979 22.0079 14.4648 22.5688 14.2094 23.0771C13.9539 23.5854 13.5832 24.027 13.1268 24.3665C12.6704 24.7061 12.1409 24.9342 11.5806 25.0327C11.0203 25.1313 10.4448 25.0975 9.89988 24.934L2.60088 22.7443C1.8492 22.5188 1.19024 22.057 0.721727 21.4275C0.253219 20.7979 0.000128693 20.0341 0 19.2493V5.8386C0.000128693 5.05383 0.253219 4.29001 0.721727 3.66044C1.19024 3.03087 1.8492 2.56909 2.60088 2.3436L9.89988 0.153897V0.153897ZM15.8145 2.81195C15.8145 2.48931 15.9427 2.17989 16.1708 1.95175C16.3989 1.72362 16.7084 1.59545 17.031 1.59545H20.6805C21.6484 1.59545 22.5767 1.97995 23.2611 2.66436C23.9455 3.34878 24.33 4.27704 24.33 5.24495V6.46145C24.33 6.78409 24.2018 7.09351 23.9737 7.32164C23.7456 7.54978 23.4361 7.67795 23.1135 7.67795C22.7909 7.67795 22.4814 7.54978 22.2533 7.32164C22.0252 7.09351 21.897 6.78409 21.897 6.46145V5.24495C21.897 4.92231 21.7688 4.61289 21.5407 4.38475C21.3126 4.15662 21.0031 4.02845 20.6805 4.02845H17.031C16.7084 4.02845 16.3989 3.90028 16.1708 3.67214C15.9427 3.44401 15.8145 3.13459 15.8145 2.81195ZM23.1135 17.4099C23.4361 17.4099 23.7456 17.5381 23.9737 17.7663C24.2018 17.9944 24.33 18.3038 24.33 18.6264V19.8429C24.33 20.8109 23.9455 21.7391 23.2611 22.4235C22.5767 23.1079 21.6484 23.4924 20.6805 23.4924H17.031C16.7084 23.4924 16.3989 23.3643 16.1708 23.1361C15.9427 22.908 15.8145 22.5986 15.8145 22.2759C15.8145 21.9533 15.9427 21.6439 16.1708 21.4158C16.3989 21.1876 16.7084 21.0594 17.031 21.0594H20.6805C21.0031 21.0594 21.3126 20.9313 21.5407 20.7031C21.7688 20.475 21.897 20.1656 21.897 19.8429V18.6264C21.897 18.3038 22.0252 17.9944 22.2533 17.7663C22.4814 17.5381 22.7909 17.4099 23.1135 17.4099ZM8.5155 11.3274C8.19286 11.3274 7.88344 11.4556 7.65531 11.6838C7.42717 11.9119 7.299 12.2213 7.299 12.5439C7.299 12.8666 7.42717 13.176 7.65531 13.4041C7.88344 13.6323 8.19286 13.7604 8.5155 13.7604H8.51672C8.83935 13.7604 9.14877 13.6323 9.37691 13.4041C9.60505 13.176 9.73322 12.8666 9.73322 12.5439C9.73322 12.2213 9.60505 11.9119 9.37691 11.6838C9.14877 11.4556 8.83935 11.3274 8.51672 11.3274H8.5155Z"
                      fill="#909090"
                    />
                    <path
                      d="M17.0312 12.5453H23.1137M23.1137 12.5453L20.6808 10.1123M23.1137 12.5453L20.6808 14.9783"
                      stroke="#C11111"
                      stroke-width="3.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </Button>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      </header>
    </>
  );
};

export default Header;
